import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function BranchList() {
  const [branches, setBranches] = useState([]);
  const [searchAddress, setSearchAddress] = useState('');
  const [searchTown, setSearchTown] = useState('');
  const [searchCity, setSearchCity] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get('https://fboothapi.azurewebsites.net/api/branch/paging?status=Active');
        setBranches(response.data);
      } catch (error) {
        console.error('Error fetching branch data:', error);
      }
    };

    fetchBranches();
  }, []);

  const handleBranchClick = (branchID) => {
    navigate(`/branchdetail/${branchID}`);
  };

  const handleCityChange = (e) => {
    setSearchCity(e.target.value);
  };

  const handleTownChange = (e) => {
    setSearchTown(e.target.value);
  };

  const handleAddressChange = (e) => {
    setSearchAddress(e.target.value);
  };

  const filteredBranches = branches.filter(branch => {
    return (
      (searchAddress === '' || branch.address === searchAddress) &&
      (searchTown === '' || branch.town === searchTown) &&
      (searchCity === '' || branch.city === searchCity)
    );
  });

  return (
    <div className="container mx-auto py-8">
      <div className="w-full p-4">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">Branches</h2>
        
        {/* Horizontal Search Filters */}
        <div className="flex items-center mb-8 space-x-4">
          <div className="flex items-center">
            <select
              value={searchAddress}
              onChange={handleAddressChange}
              className="px-4 py-2 border rounded-lg"
            >
              <option value="">Select Address</option>
              {Array.from(new Set(branches.map(branch => branch.address))).map(address => (
                <option key={address} value={address}>{address}</option>
              ))}
            </select>
          </div>
         
          <div className="flex items-center">
            <select
              value={searchTown}
              onChange={handleTownChange}
              className="px-4 py-2 border rounded-lg"
            >
              <option value="">Select Town</option>
              {Array.from(new Set(branches.map(branch => branch.town))).map(town => (
                <option key={town} value={town}>{town}</option>
              ))}
            </select>
          </div>
         
          <div className="flex items-center">
            <select
              value={searchCity}
              onChange={handleCityChange}
              className="px-4 py-2 border rounded-lg"
            >
              <option value="">Select City</option>
              {Array.from(new Set(branches.map(branch => branch.city))).map(city => (
                <option key={city} value={city}>{city}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredBranches.map(branch => (
            <div 
              key={branch.branchID} 
              className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer transform transition-transform hover:scale-105"
              onClick={() => handleBranchClick(branch.branchID)}
            >
              <img
                src={branch.branchPhotos[0]?.branchPhotoUrl || 'https://via.placeholder.com/300x200'}
                alt={branch.branchName}
                className="w-full h-56 object-cover"
              />
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-800 mb-2">{branch.branchName}</h3>
                <p className="text-gray-600 mb-1"><span className="font-bold">Address:</span> {branch.address}, {branch.town}, {branch.city}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
